import React, { useContext, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { WhatsAppCtxProvider, WhatsAppContext } from './features/whatsapp/WhatsAppContext';
import { WhatsAppChatScreen } from './features/whatsapp/WhatsAppChatScreen';
import { userHasRole } from './utils'

// your-react-components.js
const WhatsAppScreen = () => {
    const {
        isLoading,
        qrCodeHTML,
        wsState,
        getQrCode,
        operator,
        setOperator,
        websocketInstance
    } = useContext(WhatsAppContext);

    const [businessBranches, setBusinessBranches] = useState([]);
    
    return (
        <>
            {
                /*Conexão servidor: {wsState.isWsServerConnected ? 'Ativa' : 'Desativada'}<br />
                Conexão Whatsapp: {
                    wsState.isAuthenticated && wsState?.whatsAppInstanceState?.state !== 'open' ? 
                        'Autenticado Porém Sem Conexão ao WhatsApp' : (wsState?.whatsAppInstanceState?.state === 'connecting' ? 
                            'Realizando leitura do QR Code...' : (wsState.isAuthenticated && wsState?.whatsAppInstanceState?.state === 'open' ? 
                                'Autenticado e Conectado ao WhatsApp' : 'Não Realizou Autenticação'))
                }<br />*/
            }
            {userHasRole('SELLER') || userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT') ? <>
                <label>Selecione a filiai que seu whatsapp pertence</label>
                <select 
                    multiple="multiple"
                    className="form-control js-business-branches-selector my-2"
                    disabled={qrCodeHTML ? true : false}
                    onChange={(e) => { 
                        console.log('window._sessionData', window._sessionData);
                        console.log('window._sessionData.businessId', window._sessionData.businessId);
                        setOperator({
                            ...operator,
                            operator_id: window._sessionData.oldUserId,
                            company_id: window._sessionData.businessId,
                            branch_id: e.target.value,
                            roles: window._sessionData.roles,
                        })
                        $('#react-container').block(window._loader.loading);
                    }}>
                </select>

                {qrCodeHTML ? <>
                    Leia o QRCode abaixo e conecte-se ao WhatsApp:<br />
                    <img src={qrCodeHTML} /><br />
                </> : <>
                    <button 
                        className="btn btn-primary"
                        disabled={!operator || operator && operator.branch_id == false || wsState.isAuthenticated ? 'disabled' : ''} 
                        onClick={(e) => { 
                            getQrCode();
                        }}>
                        {wsState.isAuthenticated ? `Esta instância já está conectada!` : `Gerar QR Code`}
                    </button>
                </>}
            </> : userHasRole('ADMIN') || userHasRole('SUPERVISOR') ? <>
                <label>Selecione uma filial para visualizar as conversas</label>
                <select 
                    className="form-control js-business-branches-selector my-2"
                    onChange={(e) => { 
                        console.log('window._sessionData', window._sessionData);
                        console.log('window._sessionData.businessId', window._sessionData.businessId);
                        setOperator({
                            ...operator,
                            operator_id: window._sessionData.oldUserId,
                            company_id: window._sessionData.businessId,
                            branch_id: e.target.value,
                            roles: window._sessionData.roles,
                        })
                        $('#react-container').block(window._loader.loading);
                    }}>
                </select>

                <button 
                    className="btn btn-primary"
                    disabled={!operator || operator && operator.branch_id == false || !wsState.isAuthenticated ? 'disabled' : ''} 
                    onClick={(e) => { 
                        console.log('Visualizar Instância');
                    }}>
                    {!wsState.isAuthenticated ? 'Esta instância está desconectada' : 'Visualizar WhatsApp'}
                </button>
            </> : <>
                <br />Você não tem permissão para visualizar o acompanhamento via WhatsApp.
            </>}

            {wsState.isWsServerConnected ? 
                <>
                    {!wsState.isAuthenticated && (!userHasRole('ADMIN') && !userHasRole('SUPERVISOR')) ?
                        <>
                          {wsState.isAuthenticated ? <>
                            <br />
                            Esta instância está desconectada
                            <br />
                            <button 
                                className="btn btn-primary"
                                disabled={!wsState.isAuthenticated ? 'disabled' : ''} 
                                onClick={(e) => { 
                                    console.log('Desconectar Instância');
                                    if (websocketInstance.current) {
                                        websocketInstance.current.emit('data', {
                                            cmd: 'disconnectInstance',
                                            payload: {
                                                operator_id: operator.id,
                                                company_id: operator.company_id,
                                                branch_id: operator.branch_id,
                                            }
                                        })
                                    }
                                }}>
                                Desconectar Instância
                            </button>
                          </> : <><br />Instância desconectada</>} 
                        </>
                    : wsState.isAuthenticated && (userHasRole('ADMIN') || userHasRole('SUPERVISOR')) ? 
                        <>
                            <WhatsAppChatScreen />
                        </> 
                    : <></>}
                </>
            : <>
                <br />Aguardando seleção de filial para realizar conexão com Servidor.
            </>}
        </>
    );
};

try {
    if (document.getElementById('react-container')) {
        const container = document.getElementById('react-container');
        const root = createRoot(container); // createRoot(container!) if you use TypeScript
        root.render(<WhatsAppCtxProvider>
            <WhatsAppScreen />
        </WhatsAppCtxProvider>);
    }
} catch(err) {

}